var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{ref:"iframe",staticClass:"iframe",style:(_vm.getStyle()),attrs:{"srcdoc":_vm.html},on:{"load":function($event){return _vm.onIframeLoad()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }